import { Directive, HostListener, inject, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { AnalyticsService } from '@core/analytics';

@Directive({
  selector: '[analytics]',
  providers: [NgModel],
  standalone: true
})
export class AnalyticsDirective {
  analyticsService = inject(AnalyticsService);

  @Input('analytics') private eventName: string;
  @Input('analyticsData') private data: any;
  @HostListener('click')
  handleClick() {
    if (this.eventName) {
      this.analyticsService.logEvent(this.eventName, this.data);
    } else {
      console.warn('AnalyticsDirective: No "analytics" attribute value found.');
    }
  }
}
